import { useState, useContext, useEffect } from 'react';
import { ButtonGroup, ButtonGroupX, IconButton, StandardButton, TaskDropdownButton } from '../atoms/buttons';
import { PageContext, ToastContext, UserContext } from '../App';
import { icon } from '../functions/icons';
import { DropdownButton } from '../atoms/buttons';

import { PagePagination } from "../molecule/PagePagination";
import { deleteAPI, getAPI, postAPI, updateAPI } from '../api/api';
import { HorizontalLayout, VerticalLayout } from './layout';
import { Chip } from '../molecule/Chip';
import { Modal, ModalBody, ModalFooter, ModalTitle } from './modal';
import { InputForm, SelectInputForm } from '../atoms/input';
import { Alert } from './alert';
import { StandardComp } from '../atoms/standardComp';
import { IconText } from './courseComp';
import Tabs from "./tabs";
import { Search } from "../atoms/search";
import { min } from "date-fns";
import { CustomLeadScoreModal } from './customModals';
import { IconAtom } from '../atoms/iconAtom';

export const LeadComp = ({ leadData, loadLeadsData, reload }) => {
  return (
    <LeadList
      loadLeadsData={loadLeadsData}
      leads={leadData}
      reload={reload}

    />
  )
}



const LeadList = ({ leads, loadLeadsData, reload }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [generateFirst, setGenerateFirst] = useState(0);
const navigationContext = useContext(PageContext)
  const itemsPerPage = 8;
  const start = currentPage * itemsPerPage;
  const end = start + itemsPerPage;
  const viewLead = (id,index) => {
    console.log("Viewing lead with ID:", leads[start + index].info_complete );
    if(leads[start + index].no_recommendations == 0 && generateFirst === 0){
      setGenerateFirst(1)
      return 
    }
    navigationContext.handleNavigation({ ...navigationContext.sidebar, back_page: 20, navigation: 19, id_lead: id, id_lead_company: null, info_complete:leads[start + index].info_complete });
  }
  const [activeMenuLeadId, setActiveMenuLeadId] = useState(null);
  const handleToggleMenu = (leadId) => {
    setActiveMenuLeadId(prev => (prev === leadId ? null : leadId));
  };
  console.log("leads in LeadList:", leads);

  return (
    <VerticalLayout>
   {generateFirst == 1 && <CustomLeadScoreModal reload={reload} />}
    <VerticalLayout
      style={{
        borderRadius: "0.5rem",
        borderBottomLeftRadius:0,
        borderBottomRightRadius:0,
        border: "1px solid var(--grey-200)",
        height: "unset",
        marginBottom:0,
        paddingBottom:0,
        borderBottom:0,
        width: "auto"
      }}
    >
      {leads.slice(start, end).map((lead,index) => (
        <Lead
          viewLead={(id) => viewLead(id,index)}
          key={`${lead.id_lead}-${index}`}
          lead={lead}
          loadLeadsData={loadLeadsData}
          openMenu={activeMenuLeadId === lead.id_lead}
          toggleMenu={() => handleToggleMenu(lead.id_lead)}
        />
      ))}



    </VerticalLayout>
          <PagePagination
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        onPageChange={(page) => setCurrentPage(page)}
        totalUnits={leads.length}
        unitName="leads"
      />

      </VerticalLayout>
  );
};

const Lead = ({ lead, loadLeadsData, viewLead, openMenu, toggleMenu }) => {
  const [activeLead, setActiveLead] = useState(false);
  const [actionStatus, setActionStatus] = useState("");
  const navigationContext = useContext(PageContext)
  const handleAction = (action) => {
      if(action === "report"){
            navigationContext.handleNavigation({ ...navigationContext.sidebar, back_page: 20, navigation: 11, id_lead: lead.id_lead });
      }
     setActionStatus(action);
  }
  
  const isMobile = window.innerWidth <= 768;
  return (
    <div className={`employee-comp ${activeLead && "active-company"}`} onClick={() => viewLead(lead.id_lead)}>
      <LeadRow lead={lead} />
      {lead.linkedin_connected == 1 && <IconAtom icon2={"linkedin"} color="var(--primary-600)" />}
      <LeadActions handleAction={handleAction} lead={lead} openMenu={openMenu} />
      {isMobile && (<IconButton style={{ display: openMenu ? "none" : "" }} icon2={"dots-vertical"} onClick={(e) => { e.stopPropagation(); toggleMenu(); }} />)}
      <EditLeadModal loadLeads={loadLeadsData} setEditModalVisible={() => setActionStatus('')} lead={lead} editModalVisible={actionStatus == "edit"} />
      <EditDepartmentModal
        loadLeads={loadLeadsData}
        setModalVisible={() => setActionStatus('')}
        lead={lead}
        modalVisible={actionStatus == "departments"}

      />

      <RemoveLeadModal
        loadLeads={loadLeadsData}
        setModalVisible={() => setActionStatus('')}
        lead={lead}
        modalVisible={actionStatus == "delete"}
      />
    </div>
  );
};


export const LeadRow = ({ lead }) => {
  const avatarSrc = lead.avatar_url ? lead.avatar_url : `https://ui-avatars.com/api/?name=${encodeURIComponent( `${lead.first_name} ${lead.last_name}` )}&background=random&color=fff&format=svg`;
  return (
    <>
      <div style={{ marginBottom: "auto" }}>
        <img
          className="rounded-img"
          src={avatarSrc}
          alt={`${lead.first_name} ${lead.last_name} profile avatar`}
        />
      </div>
      <div className="lead-row-name" style={{ flexGrow: 1 }}>
        <p className="employee-name">
        <p className={`employee-name`} style={{ "display": "flex", gap: "0.5rem" }}>{lead.id_card && !lead.id_lead ? "Geen eigenaar" : `${lead.first_name || ""} ${lead.last_name || ""}`} {(<span className="public-badge relative">{icon(lead.id_card ? "card" : "extern", 22, "var(--primary-500)")}<div style={{ position: "absolute", top: "-.5rem", right: "-.5rem", }}>{icon("status", 12, (lead.id_card ? (lead.status === 1 && lead.active === 1) : (lead.active === 1)) ? "var(--success-500)" : "var(--grey-400)")}</div></span>)}</p> </p>
        <div style={{ flexGrow: 1 }}>
        </div>
        
        <HorizontalLayout style={{ alignItems: "center" }}>
          <p className="employee-email">{lead.email}</p>
          {lead.company_name && (
            <p className="employee-email company">• {lead.company_name}</p>
          )}
        </HorizontalLayout>
      </div>
    </>
  );

};


const LeadActions = ({ handleAction, lead, openMenu }) => {
  const userContext = useContext(UserContext)
  const canManage = userContext.permissions.includes("users.manage") && lead.id_lead;
  if (!canManage) return null;
  return (
    <ButtonGroupX
      size={`lead-actions ${openMenu && "active"}`}
      buttons={[
        {
          id: "report01",
          action: "report",
          content: <>{icon("chart")}</>,
        },
        {
          id: "edit01",
          action: "edit",
          content: <>{icon("edit")}</>,
        },
        {
          id: "departments",
          action: "departments",
          content: <>{icon("users")}</>,
        },
        {
          id: "remove01",
          action: "delete",
          content: <>{icon("trash")}</>,
        },
      ]}
      onClick={(action) => handleAction(action)}
    />
  );
};




const RemoveLeadModal = ({ setModalVisible, lead, modalVisible, loadLeads }) => {

  async function deleteLead(id_lead) {
    await deleteAPI("api/business/leads/remove", { id_lead: id_lead });
    setModalVisible(false);
    loadLeads();
  }
  return (
    <Modal
      dismissable={() => setModalVisible()}
      visible={modalVisible}
      size="small"
      content={
        <>
          <ModalTitle
            dismissable={() => setModalVisible(false)}
            hasXmark={true}
            title={`Lead verwijderen`}
          />
          <ModalBody
            style={{ maxWidth: "400px" }}
            content={
              <>
                <p className="standard-margin-bottom">
                  Weet u zeker dat u <b>{lead.first_name}</b> wilt
                  verwijderen? Al zijn/haar gegevens zullen verloren gaan.
                  Deze actie kan niet ongedaan worden gemaakt.
                </p>
                <HorizontalLayout
                  style={{ justifyContent: "flex-end", gap: "1rem" }}
                >
                  <StandardButton
                    className="secondary-button"
                    style={{ marginLeft: "0px" }}
                    title="Nee, toch niet"
                    onClick={() => setModalVisible(false)}
                  />
                  <StandardButton
                    style={{ marginLeft: "0px" }}
                    backgroundColor="error-600"
                    title="Ja, verwijder"
                    onClick={() => deleteLead(lead.id_lead)}
                  />
                </HorizontalLayout>
              </>
            }
          />
        </>
      }
    />
  )
}


const EditLeadModal = ({ setEditModalVisible, lead, editModalVisible, loadLeads }) => {
  const [editModalData, setEditModalData] = useState(lead)
  const [editModalStep, setEditModalStep] = useState(1)
  const [ErrorMessage, setErrorMessage] = useState("");
  const [originalEmail, setOriginalEmail] = useState("");
  const [emailChanged, setEmailChanged] = useState(false);
  const [roles, setRoles] = useState([]);
  const isAdmin = false
  const [confirmEmailChange, setConfirmEmailChange] = useState(false);
  function updateCreatedUser(value, key) {
    if (editModalVisible && key === "email") {
      setEmailChanged(value !== originalEmail);
      setConfirmEmailChange(false);
    }

    if (editModalVisible) {
      setEditModalData((prev) => ({ ...prev, [key]: value }));
    }
  }

  const loadRoles = async () => {
    const query = "api/business/roles";
    const loadedRoles = await getAPI(query);
    setRoles(loadedRoles.data);
    setEditModalData({ ...editModalData, id_role: loadedRoles.data[0].id })

  };
  const saveEditedEmployee = async () => {
    const query = "api/business/employee/update";
    await updateAPI(query, editModalData);
    setEditModalVisible(false);
    loadLeads();
    setErrorMessage("");
  };
  useEffect(() => {
    if (editModalVisible) return loadRoles()
  }, [])
  return (
    <Modal
      dismissable={() => setEditModalVisible(false)}
      visible={editModalVisible}
      size="small"
    >

      <ModalTitle
        dismissable={() => setEditModalVisible(false)}
        hasXmark={true}
        title={`Lead bewerken`}
      />
      <ModalBody
        style={{ maxWidth: "500px" }}
        content={
          <>
            {editModalStep === 1 && (
              <p className="standard-margin-bottom">
                <HorizontalLayout style={{ gap: "1rem" }}>
                  <InputForm
                    value={editModalData?.first_name}
                    typeInput={(v) => updateCreatedUser(v, "first_name")}
                    title="Voornaam"
                    placeholder=""
                  />
                  <InputForm
                    value={editModalData?.last_name}
                    typeInput={(v) => updateCreatedUser(v, "last_name")}
                    title="Achternaam"
                    placeholder=""
                  />
                </HorizontalLayout>
                <InputForm
                  value={editModalData?.email}
                  typeInput={(v) => updateCreatedUser(v, "email")}
                  title="Email"
                  placeholder=""
                  disabled={!isAdmin}
                />
                {ErrorMessage && (<Alert type="warning" message={ErrorMessage} className={"phone-alert-email small-standard-margin-bottom"} />)}

                <InputForm
                  value={editModalData?.company_name}
                  typeInput={(v) => updateCreatedUser(v, "company_name")}
                  title="Bedrijfsnaam"
                  placeholder="Optioneel"
                />

                <InputForm
                  value={editModalData?.phone_number}
                  typeInput={(v) => updateCreatedUser(v, "phone_number")}
                  title="Telefoonnummer"
                  placeholder="Optioneel"
                />
              </p>
            )}
            {editModalStep === 2 && (
              <p className="standard-margin-bottom">
                <HorizontalLayout
                  style={{ boxSizing: "border-box", gap: "1rem" }}
                  className="card-outline small-standard-padding standard-margin-bottom standard-border standard-rounded"
                >
                  <img
                    src={`https://ui-avatars.com/api/?name=${editModalData?.first_name} ${editModalData?.last_name}&background=random&color=fff`}
                    style={{ height: "4rem", width: "4rem" }}
                    className="rounded-img"
                  />
                  <div>
                    <b style={{ color: "var(--standard-text-color)" }}>
                      {editModalData?.first_name}{" "}
                      {editModalData?.last_name}
                    </b>
                    <p style={{ color: "var(--standard-text-color-light)" }}>
                      {editModalData?.email}
                    </p>
                  </div>
                </HorizontalLayout>
                <div className="phone-role-selector">
                  <SelectInputForm
                    style={{ width: "413px" }}
                    value={editModalData?.id_role}
                    onChange={(v) => updateCreatedUser(v, "id_role")}
                    title={`Lead rol`}
                    placeholder="Rol"
                    options={[
                      <option key="current-role" value={editModalData?.id_role} disabled selected>
                        {roles.find((r) => r.id === editModalData?.id_role)?.content || "Huidige rol"}
                      </option>,
                      ...roles
                        .filter((role) => role.id !== editModalData?.id_role)
                        .map((role) => (
                          <option key={role.id} value={role.id}>
                            {role.content}
                          </option>
                        )),
                    ]}
                  />
                </div>
              </p>
            )}
            <HorizontalLayout
              style={{ justifyContent: "flex-end", gap: "1rem" }}
            >
              {editModalStep === 1 && (
                <>
                  <StandardButton
                    className="secondary-button"
                    style={{ marginLeft: "0px" }}
                    title="Annuleren"
                    onClick={() => setEditModalVisible(false)}
                  />

                  <StandardButton
                    style={{ marginLeft: "0px" }}
                    title={<>Bewerken</>}
                    onClick={saveEditedEmployee}
                  />
                </>
              )}
              {editModalStep !== 1 && (
                <>
                  <StandardButton
                    className="secondary-button"
                    style={{ marginLeft: "0px" }}
                    title={<>Vorige</>}
                    onClick={() => setEditModalStep(1)}
                  />
                  <StandardButton
                    style={{ marginLeft: "0px" }}
                    title={<>Bewerken {icon("chevron-right")}</>}
                    onClick={saveEditedEmployee}
                  />
                </>
              )}
            </HorizontalLayout>
          </>
        }
      />

    </Modal>
  )
}

const EditDepartmentModal = ({ modalVisible, setModalVisible, selectedLeadID }) => {
  const [selectedDepartments, setSelectedDepartments] = useState([])
  const [departments, setDepartments] = useState([])
  const [createdModalData, setCreateModalData] = useState({})
  const toastContext = useContext(ToastContext)

  useEffect(() => {
    if (modalVisible) {
      loadDepartments()
    }
  }, [modalVisible])
  function addSelectedDepartment(departmentId) {
    if (!selectedDepartments.includes(departmentId)) {
      setSelectedDepartments(prev => [...prev, departmentId]);
    }
  }


  async function loadDepartments() {
    console.log("Fetching departments...");
    const response = await getAPI("api/business/departments");
    console.log("API Response:", response);

    if (response.status === "ok" && Array.isArray(response.data)) {
      console.log("Departments Data:", response.data);
      setDepartments(response.data);
    } else {
      console.error("Unexpected response format:", response);
    }
  }

  function updateCreatedUser(value, key) {



    setCreateModalData((prev) => ({ ...prev, [key]: value }));

  }

  const updateDepartments = async () => {



    const body = {
      id: selectedLeadID,
      departments: selectedDepartments.map((departmentId) => ({
        id_department: departmentId,
      }))
    }
    console.log("Selected body:", body);

    const response = await postAPI("api/users/departments/update", body);
    console.log("API Response:", response);
    if (response.status === "ok") {
      toastContext.showToast(`Doelgroep bijgewerkt`, "success");
      setModalVisible(false);
    }

  };
  return (

    <Modal
      dismissable={() => setModalVisible(false)}
      visible={modalVisible}
      size="small"
    >

      <ModalTitle
        dismissable={() => setModalVisible(false)}
        hasXmark={true}
        title={`Doelgroep aanpassen`}
      />
      <ModalBody
        style={{ maxWidth: "400px" }}
      >

        <VerticalLayout
          style={{ boxSizing: "border-box", overflow: "hidden", }}
          className="card-outline standard-margin-bottom standard-border standard-rounded"
        >
          {SelectedDepartments(
            departments,
            selectedDepartments,
            setSelectedDepartments
          )}
        </VerticalLayout>
        <HorizontalLayout>
          <DepartmentSelectors
            departments={departments}
            selectedDepartments={selectedDepartments}
            updateCreatedUser={updateCreatedUser}

            addSelectedDepartment={addSelectedDepartment}
          />
        </HorizontalLayout>
        <HorizontalLayout
          style={{ justifyContent: "flex-end", gap: "1rem" }}
        >
          <StandardButton
            className={"standard-margin-top"}
            style={{ marginLeft: "0px" }}
            title="Wijzigingen opslaan"
            onClick={updateDepartments}
          />
        </HorizontalLayout>
      </ModalBody>


    </Modal>


  );
}
function SelectedDepartments(departments, selectedDepartments, setSelectedDepartments) {
  const userInformation = useContext(UserContext)
  const isPublic = userInformation.account_type === 1
  if (selectedDepartments.length === 0) {
    return <p className="small-standard-padding">Geen {isPublic ? "doelgroepen" : "afdelingen"} gekoppeld.</p>;
  }

  return selectedDepartments.map((departmentId) => {
    const department = departments.find(
      (dept) => String(dept.id_department) === String(departmentId)
    );

    if (!department) return null;

    return (
      <VerticalLayout key={department.id_department}>
        <StandardComp
          editClass={"phone-department-comp department-comp horizontal space-between"}
          style={{ padding: "0", }}
          content={
            <>
              <p className="department-name">{department.department_name}</p>
              <div
                className="remove-icon"
                onClick={() => {
                  setSelectedDepartments((prevDepartments) => {
                    const newDepartments = prevDepartments.filter(
                      (id) => String(id) !== String(department.id_department)
                    );
                    return newDepartments;
                  });
                }}
              >
                <IconText icon2={"x"} />
              </div>
            </>
          }
        />


      </VerticalLayout>
    );
  });
}

const DepartmentSelectors = ({ departments, selectedDepartments, createModalData, updateCreatedUser, addSelectedDepartment }) => {
  const userInformation = useContext(UserContext)
  const isPublic = userInformation.account_type === 1
  return (
    <SelectInputForm
      style={{ width: "100%" }}
      value={createModalData?.id_department || ""}
      onChange={(e) => {
        const value = e?.target?.value || e;
        console.log("New Department Selected:", value);
        updateCreatedUser(value, "id_department");
        addSelectedDepartment(value);
      }}
      title={`Kies een ${isPublic ? "doelgroep" : "afdeling"}`}
      placeholder={isPublic ? "Doelgroep" : "Afdeling"}
      options={[
        <option key="dummy-option" value="" disabled>
          Selecteer een {isPublic ? "doelgroep" : "afdeling"}
        </option>,
        ...departments
          .filter((dept) => !selectedDepartments.includes(dept.id_department))
          .map((dept) => (
            <option key={dept.id_department} value={dept.id_department}>
              {dept.department_name}
            </option>
          )),
      ]}
    />
  );
}


export const AddLeadModal = ({setModalVisible, modalVisible, loadLeads}) => {
  const [createModalStep, setCreateModalStep] = useState(1)
  const [tab, setTab] = useState(2)
  const [categoryDropdown, setCategoryDropdown] = useState([]);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [companyDropdown, setCompanyDropdown] = useState([]); 
  const [searchValue, setSearchValue] = useState("");
  const [companyCategories, setCompanyCategories] = useState([]);
  const [createModalData, setCreateModalData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    company_name: "",
    phone_number: "",
    id_lead_company: null,
    name: "",
    website_url: "",
    company_linkedin_url: "",
    linkedin_url: "",
    description: "",
    scrape_word: "",
  })
  const toastContext = useContext(ToastContext)
  const createUser = async () => {
    if(createModalData.first_name.trim() === "" || createModalData.email.trim() === "") {
      toastContext.showToast("Vul minimaal de verplichte velden in: Voornaam en Email.", "error");
    }
    const query = "api/leads/create" 
    const res = await postAPI(query, createModalData);
    if(res.status ==="ok"){  
      loadLeads();
      setModalVisible(false);
      const fullName = `${createModalData.first_name} ${createModalData.last_name}`;
      toastContext.showToast(`Lead ${fullName} succesvol aangemaakt!`, "success");
    }else{
      toastContext.showToast("Er is iets misgegaan bij het aanmaken van de gebruiker. Controleer de gegevens.", "error");
    }
  };
    const updateCreatedUser = (value, field) => {
        setCreateModalData(prev => ({
            ...prev,
            [field]: value
        }));
    };
    const inputFieldsLead = [
        { key: "first_name", title: "Voornaam*", placeholder: "Jan" },
        { key: "last_name", title: "Achternaam", placeholder: "Jansen" },
        { key: "email", title: "Email*", placeholder: "Optioneel" },
        { key: "linkedin_url", title: "LinkedIn URL", placeholder: "Optioneel" },
        { key: "phone_number", title: "Telefoonnummer", placeholder: "Optioneel" },
    ];
    const inputFieldsCompany = [
        { key: "name", title: "Bedrijfsnaam*", placeholder: "Organisatie BV" },
        { key: "website_url", title: "Website URL", placeholder: "Optioneel" },
        { key: "company_linkedin_url", title: "LinkedIn URL", placeholder: "Optioneel" },
        { key: "description", title: "Beschrijving", placeholder: "Optioneel" },
        { key: "scrape_word", title: "Categorie*", placeholder: "Bouw, Technologie, Gezondheidszorg..." },
    ]
    const tabs = [
        { id: 1, title: "Organisatie maken" },
        { id: 2, title: "Organisatie kiezen" },
    ]
    const LoadCompanies = async () => {
        const query = "api/leads/companies";
        const res = await getAPI(query);
        console.log("load companies response", res) 
        setCompanyCategories(res.data);
        const categories = res.data.map((cat, index) => ({
          id: index,
          content: cat.categorie_name.replace(/"/g, ""),
          selected: false,
        }));

        setCategoryDropdown(categories);

    }
    useEffect(() => {
      if (modalVisible && tab === 2) {
        setSearchValue("");
        LoadCompanies();
      }
      setCreateModalStep(1);
      setCreateModalData({
        first_name: "",
        last_name: "",
        email: "",
        phone_number: "",
        id_lead_company: null,
        name: "",
        website_url: null,
        linkedin_url: null,
        company_linkedin_url: null,
        description: "",
        scrape_word: "",
      })
      
    }, [modalVisible, tab]);
    console.log("data", createModalData);
    const isCategorySelected = categoryDropdown.some(c => c.selected);

    const allCompaniesFlat = companyCategories.flatMap((cat, catIndex) =>
      cat.companies.map(company => ({
        ...company,
        categoryIndex: catIndex,
        categoryName: cat.categorie_name.replace(/"/g, ""),
      }))
    );
    const filteredCategoryDropdown = !isCategorySelected ? categoryDropdown.filter(cat => cat.content.toLowerCase().includes(searchValue.toLowerCase()) ) : categoryDropdown;
    const globalCompanyMatches = !isCategorySelected && searchValue ? allCompaniesFlat.filter(company => company.name.toLowerCase().includes(searchValue.toLowerCase()) ) : [];
    const displayedCompanyDropdown = (() => {
        if (isCategorySelected) {
          return companyDropdown.filter(company =>
            company.content.toLowerCase().includes(searchValue.toLowerCase())
          );
        }
        if (searchValue) {
          return globalCompanyMatches.map(company => ({
            id: company.id_lead_company,
            content: `${company.name} (${company.categoryName})`,
            selected: false,
            categoryIndex: company.categoryIndex
          }));
        }
        return allCompaniesFlat.map(company => ({
          id: company.id_lead_company,
          content: `${company.name} (${company.categoryName})`,
          selected: false,
          categoryIndex: company.categoryIndex
        }));

      })();

    const handleCategoryChange = (selected) => {
        setSearchValue("");
        if (!selected.length) {
          setCategoryDropdown(prev =>
            prev.map(c => ({ ...c, selected: false }))
          );
          setCompanyDropdown([]);
          updateCreatedUser("", "company_name");
          return;
        }

        const selectedCategoryIndex = selected[0].id;
        const category = companyCategories[selectedCategoryIndex];

        const companies = category.companies.map(company => ({
          id: company.id_lead_company,
          content: company.name,
          selected: false,
        }));

        setCompanyDropdown(companies);
        updateCreatedUser("", "company_name");
      };

    const handleCompanyChange = (selected) => {
      if (!selected.length) {
        setCompanyDropdown(prev =>
          prev.map(c => ({ ...c, selected: false }))
        );
        updateCreatedUser("", "company_name");
        return;
      }

      const selectedOption = selected[0];

      if (selectedOption.categoryIndex !== undefined) {
        const categoryIndex = selectedOption.categoryIndex;
        const category = companyCategories[categoryIndex];

        const newCategories = categoryDropdown.map(c => ({
          ...c,
          selected: c.id === categoryIndex
        }));
        setCategoryDropdown(newCategories);

        const companies = category.companies.map(company => ({
          id: company.id_lead_company,
          content: company.name,
          selected: company.id_lead_company === selectedOption.id
        }));

        setCompanyDropdown(companies);
      }

      updateCreatedUser(selectedOption.content.split(" (")[0], "name");
      updateCreatedUser(selectedOption.id, "id_lead_company");
      updateCreatedUser(selectedOption.categoryName, "scrape_word");
    };
    const handleGoNext = () => {
      if (tab === 1) {
        const requiredFields = ["name", "scrape_word"];
        const missingFields = requiredFields.filter(field => !createModalData[field]);
        if (missingFields.length) {
          toastContext.showToast("Vul alle verplichte velden in voordat je verder gaat.", "error");
          return;
        }
      } else {
        if (!createModalData.id_lead_company) {
          toastContext.showToast("Selecteer een organisatie voordat je verder gaat.", "error");
          return;
        }
      }
      setCreateModalStep(2);
    }
  return (
<Modal
  hidden={false}
  height={null}
  dismissable={() => setModalVisible(false)}
  visible={modalVisible}
  size="small"
>
  <ModalTitle
    dismissable={() => setModalVisible(false)}
    hasXmark={true}
    title={`Nieuwe lead toevoegen`}
  />
  <ModalBody style={{ maxWidth: "500px"}}>
     {createModalStep === 1 && (
      <>
        <Tabs tabs={tabs} selectedTab={tab} onTabClick={setTab} />
        {tab === 1 ? (
          <VerticalLayout className="standard-margin-top standard-margin-bottom">
              {inputFieldsCompany.slice(0,1).map((field) => (
                <InputForm
                  key={field.key}
                  value={createModalData[field.key]}
                  typeInput={(v) => updateCreatedUser(v, field.key)}
                  title={field.title}
                  placeholder={field.placeholder}
                />
              ))}
            <HorizontalLayout style={{ gap: "1rem" }}>
              {inputFieldsCompany.slice(1, 3).map((field) => (
                <InputForm
                  key={field.key}
                  value={createModalData[field.key]}
                  typeInput={(v) => updateCreatedUser(v, field.key)}
                  title={field.title}
                  placeholder={field.placeholder}
                />
              ))}
            </HorizontalLayout>
            {inputFieldsCompany.slice(3).map((field) => (
              <InputForm
                key={field.key}
                value={createModalData[field.key]}
                typeInput={(v) => updateCreatedUser(v, field.key)}
                title={field.title}
                placeholder={field.placeholder}
              />
            )
            )}
          </VerticalLayout>
        ) : (
          <VerticalLayout className="standard-margin-top standard-margin-bottom create-org-container" style={{ gap :"1rem" }}>
            <Search className={"create-org-search"} value={searchValue} onChange={setSearchValue} placeholder="Zoek categorie, bedrijf"/>
           <TaskDropdownButton
              buttonStyle={{ width: "100%" }}
              title="Categorie"
              dropdown={filteredCategoryDropdown}
              setDropdownOptions={setCategoryDropdown}
              onChange={handleCategoryChange}
              disabled={!categoryDropdown.length}
              isOpen={openDropdown === "category"}
              onToggle={() =>
                setOpenDropdown(prev => prev === "category" ? null : "category")
              }
            />

            <TaskDropdownButton
              buttonStyle={{ width: "100%" }}
              title="Bedrijf"
              dropdown={displayedCompanyDropdown}
              setDropdownOptions={setCompanyDropdown}
              onChange={handleCompanyChange}
              disabled={!companyCategories.length}
              isOpen={openDropdown === "company"}
              onToggle={() =>
                setOpenDropdown(prev => prev === "company" ? null : "company")
              }
            />

          </VerticalLayout>
        )}
      </>
    )}

    {createModalStep === 2 && (
      <>
        <Alert
          type="info"
          message={`De lead ontvangt een welkomstemail op het opgegeven e-mail adres.`}
          className={"phone-alert-email standard-margin-bottom"}
        />
        <InputForm title={"Gekozen bedrijf"} value={createModalData.name} disabled={true} />
        <HorizontalLayout style={{ gap: "1rem" }}>
          {inputFieldsLead.slice(0, 2).map((field) => (
            <InputForm
              key={field.key}
              value={createModalData[field.key]}
              typeInput={(v) => updateCreatedUser(v, field.key)}
              title={field.title}
              placeholder={field.placeholder}
            />
          ))}
        </HorizontalLayout>
          {
            inputFieldsLead.slice(2).map((field) => (
              <InputForm
                key={field.key}
                value={createModalData[field.key]}
                typeInput={(v) => updateCreatedUser(v, field.key)}
                title={field.title}
                placeholder={field.placeholder}
              />
            ))
          }
      </>
    )}
    <ModalFooter style={{ gap: "1rem", marginTop: "auto", padding: "0" }}>
       {createModalStep === 1 ? (
        <>
          <StandardButton
            className="secondary-button"
            style={{ marginLeft: "0px" }}
            title="Annuleren"
            onClick={() => setModalVisible(false)}
          />
          <StandardButton
            style={{ marginLeft: "0px" }}
            title="Volgende"
            onClick={handleGoNext}
          />
        </>
      ) : (
        <>
          <StandardButton
            className="secondary-button"
            style={{ marginLeft: "0px" }}
            title="Vorige"
            onClick={() => setCreateModalStep(1)}
          />
          <StandardButton
            style={{ marginLeft: "0px" }}
            title={<>Aanmaken {icon("chevron-right")}</>}
            onClick={createUser}
          />
        </>
      )}
    </ModalFooter>
  </ModalBody>
</Modal>

  )
}